var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0.58;}.b{clip-path:url(#a);}.c{fill:#a6bdc5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(3503 -911)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-3503 911)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3505 -908)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.453,18.851a1.857,1.857,0,0,1-.785-.172,8.293,8.293,0,0,0,3.754-3.6h6.471V13.2H11.177a8.418,8.418,0,0,0,.288-1.885h5.428V9.426H11.47V6.949L5.585,4.334V1.886A1.884,1.884,0,0,1,7.463,0h7.545l5.657,5.657v11.31a1.887,1.887,0,0,1-1.885,1.885ZM14.063,6.6h5.188L14.063,1.415ZM0,10.886V7.507L5.069,5.253l5.07,2.254v3.379a7.01,7.01,0,0,1-5.07,6.759A7.01,7.01,0,0,1,0,10.886Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsMenu);
export default __webpack_public_path__ + "static/media/claims_menu.d33cb0351e95c86e5942071127060a4b.svg";
export { ForwardRef as ReactComponent };